import React from "react";

const BaseCell = (props) => {
    const value = props.getValue();

    return <div>{value}</div>
}
export default BaseCell;